interface ICallback {
    (isHidden: boolean): void;
}

interface IRemoveEventListener {
    (): void;
}

const isHidden = (): boolean => document.hidden;

const setEvent = (callback: ICallback): IRemoveEventListener => {
    const visibilityCallback = (): void => {
        callback(isHidden());
    };

    document.addEventListener('visibilitychange', visibilityCallback, false);

    return () => {
        document.removeEventListener('visibilitychange', visibilityCallback);
    };
};

export default {
    setEvent,
    isHidden,
};
